'use client';

import { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getFootprintById } from '@/lib/actions/footprints';
import { FootprintForm } from '@/components/admin/footprints/FootprintForm';

export default function AdminFootprintEditPage() {
  const { id } = useParams<{ id: string }>();
  const [footprint, setFootprint] = useState<Awaited<ReturnType<typeof getFootprintById>>>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    getFootprintById(id).then((data) => {
      setFootprint(data);
      setLoading(false);
    });
  }, [id]);

  if (loading) {
    return null;
  }

  if (!footprint) {
    return <Navigate to="/admin/footprints" replace />;
  }

  return <FootprintForm initialData={footprint} />;
}
